// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"e976de0c","70":"71ed6e4e","71":"28dff65a","195":"80ff6a34","293":"3e7e773b","349":"07f73735","360":"8c31ec75","377":"2d387ae6","419":"23b7a9cc","606":"367e0733","621":"41aaebf4","866":"b1e60376","870":"65527e8e"}[chunkId] + ".chunk.js";
};